module.exports = __webpack_public_path__ + "36f2df2fc54c882297e20cf3d6d1e138.png";